import ApplicationAdapter from './application';
import { updateRecordWithAuditReason } from 'linced-app/utils/auditing';

export default class Person extends ApplicationAdapter {
  namespace = 'people/v4';
  modelNamePlural = 'people';
  updateRecord = updateRecordWithAuditReason;
}
